/**
 * previewFramePath — the single source of truth for the iframe preview
 * document's mount path. D-121 phase 1.
 *
 * ## Why this is its OWN module
 *
 * Both `main.tsx`'s boot seam and `PreviewFrameApp.tsx` need this literal: the
 * boot seam gates the dynamic `import()` on it, and the app re-exports it as its
 * public mount-path contract. `main.tsx` MUST NOT statically import anything
 * that transitively reaches the preview React tree — a static reach would fold
 * the code-split preview chunk back into the member entry graph (FR-018), and
 * relying on tree-shaking to keep it out is too fragile a guarantee for the
 * code-split mandate.
 *
 * This module is therefore deliberately MINIMAL and SIDE-EFFECT-FREE: a single
 * exported string constant, no imports, no React, no preview-tree reach.
 * `main.tsx` may import it directly (its few bytes folding into the member entry
 * is fine and expected); the code-split boundary stays at `mountPreviewFrame`.
 */

/** The iframe document's mount path (the boot seam in `main.tsx` matches it). */
export const PREVIEW_FRAME_PATH = '/admin/cms/preview-frame';
